import { api } from '../../lib/api';
import type { Announcement, AnnouncementInput } from './types';

// Alle Admin-Calls tragen `?app=` (aus dem globalen App-Picker): Announcements
// sind pro App (Tenant). Anlegen setzt die Ziel-App, Liste/Edit/Delete/Reach
// scopen darauf.
const q = (app: string) => `?app=${encodeURIComponent(app)}`;

export function fetchAnnouncements(app: string): Promise<Announcement[]> {
  return api.get<Announcement[]>(`/admin/announcements${q(app)}`);
}

export function fetchAnnouncement(id: string, app: string): Promise<Announcement> {
  return api.get<Announcement>(`/admin/announcements/${id}${q(app)}`);
}

export function createAnnouncement(
  input: Partial<AnnouncementInput>,
  app: string,
): Promise<Announcement> {
  return api.post<Announcement>(`/admin/announcements${q(app)}`, input);
}

export function updateAnnouncement(
  id: string,
  input: Partial<AnnouncementInput>,
  app: string,
): Promise<Announcement> {
  return api.patch<Announcement>(`/admin/announcements/${id}${q(app)}`, input);
}

export function deleteAnnouncement(id: string, app: string): Promise<void> {
  return api.delete(`/admin/announcements/${id}${q(app)}`);
}

export interface ReachStats {
  counts: { SHOWN: number; DISMISSED: number; CTA_CLICKED: number };
  distinctUsers: { SHOWN: number; DISMISSED: number; CTA_CLICKED: number };
  clickThroughRate: number;
}

export function fetchReach(id: string, app: string): Promise<ReachStats> {
  return api.get<ReachStats>(`/admin/announcements/${id}/reach${q(app)}`);
}
